import { useAuctioneerListQuery } from '../api/useAuctioneerListQuery';
import { useStartAuctionMutation } from '../api/useStartAuctionMutation';
import { useNavigate } from 'react-router-dom';
import { ApplicationRoutes } from '../../../constants/appRoutes';
import { useMemo } from 'react';
import { BaseButton, BaseMenu, useAuth } from '@cksoftware/react-base';
import { AppRoles } from '../../../constants/appRoles';

export const ConductionAuctionButton = () => {
  const startMutation = useStartAuctionMutation();
  const nav = useNavigate();
  const auth = useAuth();
  const auctionList = useAuctioneerListQuery(auth.isAuthenticated && auth.isInRole([AppRoles.Auctioneer]));

  const onStartAuction = async (auctionId: number) => {
    await startMutation.mutateAsync({ auctionId });
    nav(`${ApplicationRoutes.liveAuction.auctioneer}/${auctionId}`);
  };

  const menuItems = useMemo(() => {
    if (!auctionList.data) {
      return [];
    }
    return auctionList.data.map((val) => {
      return {
        onClick: () => onStartAuction(Number(val.Value!)),
        text: val.Label
      };
    });
  }, [onStartAuction, auctionList.data]);

  if (!auth.isAuthenticated || !auth.isInRole([AppRoles.Auctioneer])) {
    return undefined;
  }

  return (
    <>
      <BaseMenu items={menuItems}>
        <BaseButton w={'250px'} variant={'secondary'}>
          Conduct Auction
        </BaseButton>
      </BaseMenu>
    </>
  );
};
